/**
 * 常量定义
 */

// API端点
export const API_ENDPOINTS = {
  // 域名管理
  DOMAINS: '/domains',
  ADD_DOMAIN: '/adddomain',
  DELETE_DOMAIN: '/delete_domain',
  SUSPEND_DOMAIN: '/suspend_domain',
  
  // DNS记录
  RECORDS: '/records',
  ADD_RECORD: '/add_record',
  EDIT_RECORD: '/edit_record',
  DELETE_RECORD: '/delete_record',
  DISABLE_RECORD: '/disable_record',
  
  // IP/PTR
  GET_IPS: '/getips',
  ADD_PTR: '/addptr',
  
  // DNSSEC
  DNSSEC: '/dnssec',
  DNSSEC_STATUS: '/dnssec_status',
  DNSSEC_ENABLE: '/dnssec_enable',
  DNSSEC_DISABLE: '/dnssec_disable',
  
  // 其他
  RECORD_TYPES: '/record_types',
  ACTION_LOG: '/getactionlog',
  CHECK_TOKEN: '/checktoken',
  DASHBOARD_STATISTICS: '/dashboard/statistics',
  
  // API凭证管理
  API_CREDENTIALS: '/credentials',
  API_CREDENTIAL: '/credentials', // 单个凭证（需要ID）
  API_CREDENTIAL_STATUS: '/credentials', // 启用/禁用（需要ID）
  API_CREDENTIAL_LOGS: '/credentials', // 调用日志（需要ID）
  API_CREDENTIAL_STATISTICS: '/credentials' // 统计信息（需要ID）
}

// OAuth端点
export const OAUTH_ENDPOINTS = {
  LOGIN: '/oauth/login',
  CALLBACK: '/oauth/callback'
}

// 路由名称
export const ROUTE_NAMES = {
  LOGIN: 'login',
  REGISTER: 'register',
  HOME: 'home',
  DNS_LIST: 'dnslist',
  DOMAIN_RECORD: 'domainrecord',
  DNSSEC: 'dnssec',
  IP_PTR: 'ipptr',
  IP_PTR_RECORD: 'ipptrrecord',
  API_CREDENTIALS: 'apicredentials',
  API_CREDENTIAL_DETAIL: 'apicredentialdetail'
}

// 公共页面路径
export const PUBLIC_PAGES = ['/login', '/register', '/forgot-password']

// 每页显示选项
export const PAGE_OPTIONS = [10, 25, 50, 100]

// 默认配置
export const DEFAULT_CONFIG = {
  PAGE_SIZE: 10,
  TIMEOUT: 30000
}

// 加密密钥（应该从配置中读取，这里保持向后兼容）
export const AES_KEY = "29xf2OGBGHqWNn7xZExtQuLFic0V8JMp"

// 消息类型
export const MESSAGE_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info'
}

